/* eslint-disable no-console */
/* eslint-disable react/jsx-props-no-spreading */
import {
  Redirect,
  Route as RouterRoute,
  RouteComponentProps,
} from 'react-router-dom'

import { useAuth } from '../auth/AuthProvider'
import { getEnvs } from '../utils/env'
import { locations } from '../utils/locations'
import type { Route } from './config'

const { bypassLogin } = getEnvs()

const loadRouteComponent = (
  props: RouteComponentProps<
    { [x: string]: string | undefined },
    object,
    unknown
  >,
  route: Route
) =>
  route.component &&
  route.template && (
    <route.template>
      <route.component {...props} />
    </route.template>
  )

export const Routes = (route: Route): JSX.Element => {
  const { isAuthenticated } = useAuth()
  const isUserAuthenticated = bypassLogin || isAuthenticated
  const { path, redirect, isPrivate } = route
  console.log('isUserAuthenticated ', isUserAuthenticated)

  return (
    <RouterRoute
      path={path}
      render={(props) => {
        console.log('path ', path)
        if (redirect) {
          console.log('redirect to ', redirect)
          return <Redirect to={redirect} />
        }

        if (path === locations.signIn) {
          return isUserAuthenticated ? (
            <Redirect to={locations.loggedInRedirect} />
          ) : (
            loadRouteComponent(props, route)
          )
        }

        if (!isPrivate) {
          return loadRouteComponent(props, route)
        }

        return isUserAuthenticated ? (
          loadRouteComponent(props, route)
        ) : (
          <Redirect to={locations.signIn} />
        )
      }}
    />
  )
}
